// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WhatsNewCard_wrapper__x3x-q","read-more":"WhatsNewCard_read-more__2T1R2"};